var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetvisor = function SvgNetvisor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#netvisor_csvg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095F8",
    d: "M27.343 16.568c-6.787-4.192-13.64-8.45-16.302-5.855l-.2.2c-1.796 2.262.666 7.186 3.86 12.509.599.998 1.264 2.063 1.863 3.127 6.787 4.192 13.707 8.517 16.302 5.856 2.595-2.595-1.464-9.25-5.523-15.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005F9E",
    d: "M10.842 10.912 6.65 15.104l-5.59 5.59c-.066.066-.133.133-.266.2-3.393 3.393 4.724 13.773 9.316 22.09l5.19-5.19a9.43 9.43 0 0 0 2.661-5.456c.267-2.063-.2-4.125-1.33-5.922v-.066a77 77 0 0 1-1.864-3.128c-3.26-5.19-5.722-10.047-3.925-12.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02D1E4",
    d: "m33.864 0-5.19 5.19a9.43 9.43 0 0 0-2.661 5.456c-.267 2.063.2 4.126 1.33 5.922 4.06 6.654 8.118 13.308 5.59 15.837L43.18 22.158c3.393-3.46-4.724-13.84-9.316-22.158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0095F8",
    d: "M27.343 16.568c-6.787-4.192-13.64-8.45-16.302-5.855l-.2.2c-1.796 2.262.666 7.186 3.86 12.509.599.998 1.264 2.063 1.863 3.127 6.787 4.192 13.707 8.517 16.302 5.856 2.595-2.595-1.464-9.25-5.523-15.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005F9E",
    d: "M16.63 26.55c-6.454-4.06-12.842-7.919-15.57-5.79a.9.9 0 0 1-.266.2c-3.393 3.393 4.724 13.774 9.316 22.091l5.19-5.19a9.43 9.43 0 0 0 2.661-5.456c.2-2.063-.266-4.126-1.33-5.856Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007ACA",
    d: "M14.7 23.422c-3.193-5.323-5.655-10.247-3.858-12.51L6.65 15.104l-5.59 5.59c2.728-2.063 9.116 1.796 15.504 5.789-.599-.998-1.264-2.063-1.863-3.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64E5DB",
    d: "m33.864 0-5.19 5.19a9.43 9.43 0 0 0-2.661 5.456c-.267 2.063.2 4.126 1.33 5.922 6.654 4.06 13.242 8.118 15.837 5.59 3.393-3.46-4.724-13.84-9.316-22.158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02D1E4",
    d: "M27.343 16.568c4.06 6.654 8.118 13.308 5.59 15.837L43.18 22.158c-2.595 2.462-9.183-1.597-15.837-5.59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "netvisor_csvg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgNetvisor;